/*
 *
 * IntermediateShelfPanel actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes from './constants';
import { Color } from 'lib/modelBuilder/entities/Color';

export const displayIntermediateShelfPanelAction = (value: boolean) =>
  action(ActionTypes.DISPLAY_INTERMEDIATE_SHELF_PANEL, { value });

export const selectionIntermediateShelvesAction = (values?: number[]) =>
  action(ActionTypes.SELECTION_INTERMEDIATE_SHELVES, { values });

// Add
export const addIntermediateShelvesOnSelectionAction = (
  height?: number,
  position?: number,
  color?: Color,
) =>
  action(ActionTypes.ADD_INTERMEDIATE_SHELVES_ON_SELECTION, {
    height,
    position,
    color,
  });
export const addColorIntermediateShelvesOnSelectionFailure = (error: Error) =>
  action(ActionTypes.ADD_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE, {
    error,
  });

// Remove
export const removeIntermediateShelvesOnSelectionAction = (
  positions: number[],
  all = false,
) =>
  action(ActionTypes.REMOVE_INTERMEDIATE_SHELVES_ON_SELECTION, {
    positions,
    all,
  });
export const removeColorIntermediateShelvesOnSelectionFailure = (
  error: Error,
) =>
  action(ActionTypes.REMOVE_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE, {
    error,
  });

// Colors
export const updateColorIntermediateShelvesOnSelectionAction = (
  color: Color,
  preview: boolean,
) =>
  action(ActionTypes.UPDATE_COLOR_INTERMEDIATE_SHELVES_ON_SELECTION, {
    color,
    preview,
  });
export const updateColorIntermediateShelvesOnSelectionFailure = (
  error: Error,
) =>
  action(ActionTypes.UPDATE_COLOR_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE, {
    error,
  });

// Height
export const updateHeightIntermediateShelvesOnSelectionAction = (
  value: number,
  preview: boolean,
) =>
  action(ActionTypes.UPDATE_HEIGHT_INTERMEDIATE_SHELVES_ON_SELECTION, {
    value,
    preview,
  });
export const updateHeightIntermediateShelvesOnSelectionFailure = (
  error: Error,
) =>
  action(ActionTypes.UPDATE_HEIGHT_INTERMEDIATE_SHELVES_ON_SELECTION, {
    error,
  });

// Depth
export const updateDepthIntermediateShelvesOnSelectionAction = (
  value: number,
  preview: boolean,
) =>
  action(ActionTypes.UPDATE_DEPTH_INTERMEDIATE_SHELVES_ON_SELECTION, {
    value,
    preview,
  });
export const updateDepthIntermediateShelvesOnSelectionFailure = (
  error: Error,
) =>
  action(ActionTypes.UPDATE_DEPTH_INTERMEDIATE_SHELVES_ON_SELECTION_FAILURE, {
    error,
  });
